import React from "react";
import { Link } from 'react-router-dom'
import Header from "../../Components/Header";
import UniversalBanner from "../../Components/UniversalBanner";
import Footer from "../../Components/Footer";
import Newsletter from "../../Components/Newsletter";
// import 'primeicons/primeicons.css';
import {
    Therapist8Img
} from "../../Constant/Index";


const ThankYou = () => {

    return (
        <>
            <Header />
            <UniversalBanner heading="Thank You" />
            <section className="thankyou-section py-5">
                <div className="container">
                    <div className="thankyou-start pb-4">
                        <div className="top-heading col-lg-5 px-2 col-md-8  mx-auto text-center pb-3">
                            <h6 className="xs-heading">Say Hi to Therapist</h6>
                            <p className="text">Your Appointment has been confirmed, Your Requested be available to be available on Friday, 27th of June at 10:30 - 11:30 AM.</p>
                        </div>
                        <div className="thankyou-card col-lg-4 col-md-8 with-radius mx-auto pt-md-3 pb-2">
                            <div className="col-md-6 mx-auto pt-0 py-md-4 pb-4 ">
                                <figure className="main-image">
                                    <img src={Therapist8Img} className="img-here with-radius-sm w-100" alt="" />
                                </figure>
                                <div className="text-here text-center pt-4 pb-3">
                                    <h6 className="xs-heading mb-1 mediam-font">Peter Williams</h6>
                                    <span className="role">Psychotherapist</span>
                                </div>
                                <Link className="btn secondary-btn d-flex align-items-center gap-2 width-fit mx-auto text-decoration-none ">
                                    <span className="icon-here">
                                        <svg width="14" height="15" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.25 0C3.70095 0 0 3.33135 0 7.425C0 11.7637 4.158 15.2691 9.075 14.8112V17.4017L10.3455 16.5866C11.2794 15.9877 15.9613 12.7685 16.453 8.21288C16.4835 7.95383 16.5 7.69065 16.5 7.425C16.5 3.33135 12.799 0 8.25 0ZM5.775 8.25H4.125V6.6H5.775V8.25ZM9.075 8.25H7.425V6.6H9.075V8.25ZM12.375 8.25H10.725V6.6H12.375V8.25Z" fill="white" />
                                        </svg>
                                    </span>
                                    Chat Now</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Newsletter />
            <Footer />
        </>
    )
}
export default ThankYou;